var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowTilted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91354 9.91386L8.72398 9.89986L8.72398 2.98642L1.3767 10.3337L0.537014 9.49401L7.8843 2.14673L0.970853 2.14673L0.956859 0.957173L9.91354 0.957173L9.91354 9.91386Z",
    fill: "#6CBF7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowTilted);
export default __webpack_public_path__ + "static/media/upArrowTilted.9321d37ab8585af6c4eee217f60667e8.svg";
export { ForwardRef as ReactComponent };